import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { ProductForm } from "./ProductForm";
import { useParams } from "react-router";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { ProductFormV2 } from "src/pages/Product/v2/ProductFormV2/ProductFormV2";

export const CreateQuestionnaire = () => {
    const { startingPageId } = useParams();
    const { company } = useCompanyMetadata();
    const isProductUxV2 = useIsProductUxV2();

    const commonProps = {
        companyIds: {
            id: company.id,
            "@id": company["@id"],
            name: company.name,
        },
        startingPageId: startingPageId ?? "0",
        productReference: undefined,
        existingProduct: undefined,
    };

    if (isProductUxV2) {
        return <ProductFormV2 {...commonProps} />;
    }

    return <ProductForm {...commonProps} />;
};
